import React, { useEffect, useState } from "react"

import {
  AnnouncementsItemType,
  FeedbackSurvey
} from "../../../../mp-database/contextHelpManager"
import { useLocation } from "react-router-dom"
import {
  saveFeedbackSurvey,
  updateAnnouncements
} from "../../../../mp-core/redux/modules/users"
import { RootState } from "../../../../mp-core/redux/store"
import { useSelector, useDispatch } from "react-redux"
import { User } from "../../../../mp-database"
import GhostieCard from "../../../generic-shared-components/components/GhostieCard"
import { TEACHER_FEEDBACK_ID } from "../../../../mp-core/components/FeedbackTray/constants"

interface Props {
  data: AnnouncementsItemType[]
  type: string
  isHidden?: boolean // collapsed out of screen
  isOpenInitially?: boolean
  setSelectedCard?: () => void // for mobile views
  onClickCustomButton?: () => void
}

const GhostieCardContainer: React.FC<React.PropsWithChildren<Props>> = ({
  data,
  type,
  isHidden,
  isOpenInitially = false,
  setSelectedCard,
  onClickCustomButton
}) => {
  const [open, setOpen] = useState<boolean>(isOpenInitially)
  const [currentPage, setCurrentPage] = useState(1)
  const [selectedItem, setSelectedItem] = useState<AnnouncementsItemType>()
  const [showLearnMoreModal, setShowLearnMoreModal] = useState<boolean>(false)
  const [currentData, setCurrentData] = useState<AnnouncementsItemType[]>(data)
  const [onUpdateLoading, setOnUpdateLoading] = useState<{
    [key: string]: boolean
  }>({})

  const location = useLocation()

  const dispatch = useDispatch() as any
  const { user } = useSelector((state: RootState) => {
    return {
      user: state.users.testUser as User
    }
  })

  const totalPages = currentData.length

  const updateAnnouncement = async (
    user: User,
    announcement: AnnouncementsItemType
  ) => {
    if (announcement.id) {
      setOnUpdateLoading({ ...onUpdateLoading, [announcement.id]: true })
      await dispatch(updateAnnouncements(user, announcement))
      setOnUpdateLoading({ ...onUpdateLoading, [announcement.id]: false })
      setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)
    }
  }

  const handleLearnMoreModal = (item?: AnnouncementsItemType) => {
    setSelectedItem(item)
    setShowLearnMoreModal(!showLearnMoreModal)
  }

  const openCardHandler = () => {
    setOpen(!open)
    if (setSelectedCard) setSelectedCard()
  }

  const submitCardHandler = (item: AnnouncementsItemType) => {
    if (item.id === TEACHER_FEEDBACK_ID) return

    updateAnnouncement(user, item)
  }

  const changePageHandler = (nextPage: number) => {
    setCurrentPage(nextPage)
  }

  const isLoadingItem = (id: string) => {
    return onUpdateLoading?.[id]
  }

  useEffect(() => {
    setOpen(isOpenInitially)
  }, [location])

  const onSendFeedbackClick = async (fb: FeedbackSurvey) => {
    try {
      setOnUpdateLoading({ ...onUpdateLoading, feedback_request: true })
      await dispatch(saveFeedbackSurvey(fb, user))
      setOnUpdateLoading({ ...onUpdateLoading, feedback_request: false })
      setCurrentData(prev =>
        prev.filter(item => item.id !== "onboarding-survey")
      )
      setOpen(false)
    } catch (error) {
      console.error({ error })
    }
  }

  return (
    !!currentData.length && (
      <GhostieCard
        data={currentData}
        selectedItem={selectedItem}
        currentPage={currentPage}
        totalPages={totalPages}
        type={type}
        isCardOpen={open}
        isCardHidden={isHidden}
        isLearnMoreOpen={showLearnMoreModal}
        isLoadingItem={isLoadingItem}
        onOpenClose={openCardHandler}
        submitCardHandler={submitCardHandler}
        onClickCustomButton={onClickCustomButton}
        learnMoreModalHandler={handleLearnMoreModal}
        onSendFeedbackClick={onSendFeedbackClick}
        onChangePage={changePageHandler}
      />
    )
  )
}

export default GhostieCardContainer
